import React from 'react';

import AboveTheFoldOnlyServerRender from '../../shared/components/above-the-fold-only-server-render';

import PDPNav from './sticky-nav';
import PDPDetails from './pdp-details';
import SoftBundle from './soft-bundle';
import ReturnsAndExchange from './returns-exchange-info';
import OOSPopup from './oos-popup';
import LoadingPlaceholder from './loading-placeholder';
import ResetScrollPosition from './reset-scroll-position';
import ThemeCSSLoader from './theme-css-loader';
import { WithTheme } from '../../hooks/useTemplateTheme';
import PDPLayout from './pdp-layout';

import './pdp.less';

const PDP = () => {
    return (
        <WithTheme CSSLoader={ThemeCSSLoader}>
            <ResetScrollPosition />
            <LoadingPlaceholder />
            <PDPDetails />
            <SoftBundle />
            <PDPNav />
            <div id="nav-boundary"></div>
            <PDPLayout />
            <AboveTheFoldOnlyServerRender skip={true} renderOn="load" robots={true}>
                <ReturnsAndExchange />
            </AboveTheFoldOnlyServerRender>
            <AboveTheFoldOnlyServerRender skip={true} renderOn="load">
                <OOSPopup />
            </AboveTheFoldOnlyServerRender>
        </WithTheme>
    );
};

export default PDP;
